import React from "react";
import { TextField } from "./fields/TextField";
import { TextareaField } from "./fields/TextareaField";
import { RadioField } from "./fields/RadioField";
import { CheckboxField } from "./fields/CheckboxField";
import { SliderField } from "./fields/SliderField";
import { ColorField } from "./fields/ColorField";
import { ImagePickField } from "./fields/ImagePickField";
import { FileField } from "./fields/FileField";
import { FileLinkField } from "./fields/FileLinkField";
import { BrandField } from "./fields/BrandField";
import { AgeGridField } from "./fields/AgeGridField";

// Maps QuestionBrand.answer_type → component. Visual / option-driven types
// (font, texture, brand, shade, image_pick) all share the same image-grid
// renderer; the difference is purely in the option metadata configured by
// the admin.
const REGISTRY = {
  input: TextField,
  textarea: TextareaField,
  radio: RadioField,
  checkbox: CheckboxField,
  bar: SliderField,        // legacy "bar" === slider (now bipolar-capable)
  color: ColorField,
  shade: ColorField,
  font: ImagePickField,
  texture: ImagePickField,
  brand: BrandField,       // toggle (PRODUCT/SERVICE) + textarea compound
  image_pick: ImagePickField,
  file: FileField,
  "file/link": FileLinkField,
  age_grid: AgeGridField,  // gender toggle + 2-row character cards
  // Legacy alias — production data has answer_type='age-data' for the same
  // gender + age-band grid. Map it onto the same component so old questions
  // render correctly without a migration.
  "age-data": AgeGridField,
  // Legacy "thumbnail" type renders a small grid of image cards with labels
  // (capitalisation styles AA / aa / Aa, logo styles, etc.). Functionally
  // identical to image_pick — same option-grid visual.
  thumbnail: ImagePickField,
  // Legacy "brand2" — same image-card grid as thumbnail, used for the
  // illustration-format picker on page 6 of the legacy questionnaire.
  brand2: ImagePickField,
};

export const FieldRenderer = ({ question, value, onChange, lang }) => {
  const Comp = REGISTRY[question.answer_type];
  if (!Comp) {
    // Unknown / unsupported types — show a graceful read-only fallback
    // rather than blowing up the whole questionnaire.
    return (
      <div className="dq-empty">
        Unsupported field type: <code>{question.answer_type}</code>
      </div>
    );
  }
  return <Comp question={question} value={value} onChange={onChange} lang={lang} />;
};
